var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy_svg__clip0_3831_4102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66661 5.66667V3.48904C5.66661 2.61785 5.66661 2.18193 5.83615 1.84918C5.98529 1.55648 6.22308 1.31868 6.51578 1.16955C6.84852 1 7.28444 1 8.15562 1H12.5111C13.3823 1 13.8177 1 14.1504 1.16955C14.4431 1.31868 14.6813 1.55648 14.8305 1.84918C15 2.18193 15 2.61752 15 3.48872V7.84429C15 8.71549 15 9.15108 14.8305 9.48383C14.6813 9.77653 14.4429 10.0148 14.1502 10.164C13.8178 10.3333 13.3829 10.3333 12.5134 10.3333H10.3332M5.66661 5.66667H3.48901C2.61783 5.66667 2.18191 5.66667 1.84917 5.83621C1.55647 5.98535 1.31868 6.22315 1.16954 6.51584C1 6.84859 1 7.28451 1 8.15571V12.5113C1 13.3825 1 13.8178 1.16954 14.1506C1.31868 14.4433 1.55647 14.6815 1.84917 14.8306C2.18159 15 2.61698 15 3.48645 15H7.84713C8.71661 15 9.15139 15 9.48381 14.8306C9.7765 14.6815 10.0147 14.443 10.1638 14.1503C10.3332 13.8179 10.3332 13.383 10.3332 12.5135V10.3333M5.66661 5.66667H7.84452C8.7157 5.66667 9.15106 5.66667 9.48381 5.83621C9.7765 5.98535 10.0147 6.22315 10.1638 6.51584C10.3332 6.84827 10.3332 7.28367 10.3332 8.15318L10.3332 10.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_svg__clip0_3831_4102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
};
export default SvgCopy;